/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Get_1Inputs */

const en_cp_lead_get_1 = /** @type {(inputs: Cp_Lead_Get_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 free Campus seat for an academic year, Opus 5 included`)
};

const id_cp_lead_get_1 = /** @type {(inputs: Cp_Lead_Get_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 kursi paket Kampus gratis 1 tahun akademik, termasuk Opus 5`)
};

/**
* | output |
* | --- |
* | "1 free Campus seat for an academic year, Opus 5 included" |
*
* @param {Cp_Lead_Get_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_get_1 = /** @type {((inputs?: Cp_Lead_Get_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Get_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_get_1(inputs)
	return en_cp_lead_get_1(inputs)
});